// 展示模式（SPEC #vms-web-demo-jp「畫面條件」）：網址帶 ?present=1 時記在本分頁（sessionStorage），之後換頁也維持；
// 只影響畫面——不畫「環境：dev / test」標籤與開發用底圖提示，頂列多一顆〔展示結束〕。不改資料、不影響權限。
const KEY = 'kinio.vms.present';

/** 讀網址的 ?present=1（有就記下來），回本分頁是不是在展示模式。 */
export function isPresentMode(search: string = typeof location === 'undefined' ? '' : location.search): boolean {
  try {
    if (new URLSearchParams(search).get('present') === '1') sessionStorage.setItem(KEY, '1');
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false; // 無 storage：照一般畫面
  }
}

/** 〔展示結束〕：清掉記號；呼叫端接著重新整理（網址的 ?present=1 也要拿掉，不然又進來）。 */
export function endPresentMode(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* 無 storage */
  }
}

/** 拿掉網址的 present 參數（其他參數照留）。 */
export function withoutPresentParam(href: string): string {
  const u = new URL(href);
  u.searchParams.delete('present');
  return u.toString();
}
